module.exports = __webpack_public_path__ + "img/探索我们的企业使命.9c7f0171.png";